import { ComponentProps } from 'react';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import CompassButton from '../CompassButton';
import ZoomButtons from '../ZoomButtons';
import ControlContainer from '../ControlContainer';
import StyleButton from '../StyleButton';
import TerrainButton from '../TerrainButton';
import CurrentLocationButtonAndMarker from '../CurrentLocationButtonAndMarker';
import { mapControlsTopRightContainerId } from '../../utils/constants';
import styles from './styles/styles.module.scss';

export type MapControlsProps = {
  onCompassButtonClick?: () => void;
  onCurrentLocationButtonClick?: () => void;
  onTerrainButtonClick?: () => void;
  onZoomInButtonClick?: () => void;
  onZoomOutButtonClick?: () => void;
  showCurrentLocation?: boolean;
} & Pick<
  ComponentProps<typeof StyleButton>,
  | 'disableAnalytics'
  | 'handleFailedEntitlementCheck'
  | 'isStyleModalInitiallyOpen'
  | 'mapLocation'
  | 'onMapBaseLayerTapped'
  | 'onMapOverlayTapped'
  | 'onStyleModalChange'
  | 'pauseFocusTrap'
>;

const MapControls = ({
  disableAnalytics,
  handleFailedEntitlementCheck,
  isStyleModalInitiallyOpen,
  mapLocation,
  onCompassButtonClick,
  onCurrentLocationButtonClick,
  onMapBaseLayerTapped,
  onMapOverlayTapped,
  onStyleModalChange,
  onTerrainButtonClick,
  onZoomInButtonClick,
  onZoomOutButtonClick,
  pauseFocusTrap,
  showCurrentLocation
}: MapControlsProps) => {
  const isMobile = useIsMobileSizedScreen();

  return (
    <ControlContainer className={styles.topRightButtons} compactSpacing id={mapControlsTopRightContainerId} position="topRight">
      <StyleButton
        disableAnalytics={disableAnalytics}
        handleFailedEntitlementCheck={handleFailedEntitlementCheck}
        isStyleModalInitiallyOpen={isStyleModalInitiallyOpen}
        mapLocation={mapLocation}
        onMapBaseLayerTapped={onMapBaseLayerTapped}
        onMapOverlayTapped={onMapOverlayTapped}
        onStyleModalChange={onStyleModalChange}
        pauseFocusTrap={pauseFocusTrap}
      />
      <TerrainButton onClick={onTerrainButtonClick} />
      {!isMobile && <ZoomButtons onZoomInClick={onZoomInButtonClick} onZoomOutClick={onZoomOutButtonClick} />}
      {showCurrentLocation && <CurrentLocationButtonAndMarker onClick={onCurrentLocationButtonClick} />}
      {/* The compass icon that indicates the current map bearing/direction */}
      <CompassButton onClick={onCompassButtonClick} />
    </ControlContainer>
  );
};

export default MapControls;
